module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"showLess":"collapse","showMore":"what\u0027s this?"}}')
  delete Component.options._Ctor
}
